import { helper } from '@ember/component/helper';

const MINUTES_PER_HOUR = 60;

/**
 * Formatta minuti in stringa ore:minuti
 */
function formatMinute2string([minutes]) {
  if (minutes == null || isNaN(minutes)) return '0 h';
  const totalMinutes = parseFloat(minutes);
  // Compute on the absolute value: floor/modulo on negatives produced
  // garbage like "-2 h -30 m" for -90.
  const absMinutes = Math.abs(totalMinutes);
  const hours = Math.floor(absMinutes / MINUTES_PER_HOUR);
  const mins = Math.floor(absMinutes % MINUTES_PER_HOUR);
  const parts = [];
  if (hours) parts.push(`${hours} h`);
  if (mins) parts.push(`${mins} m`);
  if (parts.length === 0) return '0 h';
  return `${totalMinutes < 0 ? '-' : ''}${parts.join(' ')}`;
}
var formatMinute2string$1 = helper(formatMinute2string);

export { formatMinute2string$1 as default, formatMinute2string };
//# sourceMappingURL=format-minute2string.js.map
